import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Modal, Button } from 'react-bootstrap';
import { getVariables, updateTableBd } from '../../../config/functions';
import { SelectorNemotecnicoWitsml } from './SelectorNemotecnicoWitsml';

export const ModalVarEdit = (
    {
        variableAll,
        variables = [],
        setIsLoading,
        show,
        handleClose,
        setVariables,
        user
    }
) => {

    const idVar = variableAll.nb_var_idn

    const [variable, setVariable] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [unidad, setUnidad] = useState('')

    // Estados para homologación estándar WITSML
    const [witsmlNemo, setWitsmlNemo] = useState(null)
    const [witsmlDes, setWitsmlDes] = useState(null)
    const [witsmlUmd, setWitsmlUmd] = useState(null)
    const [witsmlFactor, setWitsmlFactor] = useState(1.0)

    useEffect(() => {
        if (show) {
            setVariable(variableAll.vr_var_nom || '')
            setDescripcion(variableAll.vr_var_des || '')
            setUnidad(variableAll.vr_var_umd || '')
            setWitsmlNemo(variableAll.vr_var_witsml_nemo || null)
            setWitsmlDes(variableAll.vr_var_witsml_des || null)
            setWitsmlUmd(variableAll.vr_var_witsml_umd || null)
            setWitsmlFactor(
                variableAll.vr_var_witsml_conv_factor !== undefined && variableAll.vr_var_witsml_conv_factor !== null
                    ? parseFloat(variableAll.vr_var_witsml_conv_factor)
                    : 1.0
            )
        }
    }, [show, variableAll])

    const handleWitsmlChange = (data) => {
        setWitsmlNemo(data.vr_var_witsml_nemo)
        setWitsmlDes(data.vr_var_witsml_des)
        setWitsmlUmd(data.vr_var_witsml_umd)
        setWitsmlFactor(data.vr_var_witsml_conv_factor)
    }

    const updateVar = async () => {
        if (variable !== '' && unidad !== '') {
            const variableEnUso = witsmlNemo && Array.isArray(variables)
                ? variables.find(v => v.vr_var_witsml_nemo === witsmlNemo && parseInt(v.nb_var_idn) !== parseInt(idVar))
                : null;

            let mensajeConfirmacion = '¿Está seguro de continuar con la edición?';
            if (variableEnUso) {
                mensajeConfirmacion = `El nemotécnico WitsML "${witsmlNemo}" ya está asociado a la variable "${variableEnUso.vr_var_tag} (${variableEnUso.vr_var_nom})".\n\nSi continúa, se desasociará de dicha variable y se transferirá a la variable actual.\n\n¿Desea continuar?`;
            }

            if (window.confirm(mensajeConfirmacion)) {
                setIsLoading(true)
                try {
                    const fecha = new Date()
                    const dataSend = {
                        vr_var_nom: variable,
                        nb_var_idn: parseInt(idVar),
                        vr_var_des: descripcion,
                        vr_var_umd: unidad,
                        vr_adt_usureg: user,
                        dt_adt_fchreg: fecha.toISOString(),
                        vr_var_witsml_nemo: witsmlNemo || null,
                        vr_var_witsml_des: witsmlDes || null,
                        vr_var_witsml_umd: witsmlUmd || null,
                        vr_var_witsml_conv_factor: witsmlFactor !== '' && witsmlFactor !== null && witsmlFactor !== undefined
                            ? parseFloat(witsmlFactor)
                            : 1.0
                    }
                    const update = await updateTableBd('updatevar', dataSend)
                    toast.success(update);
                    getVariables(setVariables);
                    handleClose()
                } catch (error) {
                    console.error('Error al realizar la solicitud:', error);
                } finally {
                    setIsLoading(false)
                }
            }
        } else {
            toast.warning('Debe diligenciar Nombre y unidad de medida')
        }
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} dialogClassName="modal-themed-dialog">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Edición de variable: {variableAll.vr_var_tag}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3 justify-content-center">
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1">Nombre</span>
                            <input type="text"
                                className="form-control"
                                placeholder="Nombre"
                                aria-label="Nombre"
                                value={variable}
                                onChange={(e) => setVariable(e.target.value)} />
                        </div>
                    </div>

                    <div className="row g-3 justify-content-center">
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1">Descripción</span>
                            <textarea
                                type="text"
                                className="form-control"
                                placeholder="Descripción"
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)} />
                        </div>
                    </div>

                    <div className="row g-3 justify-content-center">
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1">Unidad de Medida</span>
                            <input type="text"
                                className="form-control"
                                placeholder="UDM"
                                value={unidad}
                                onChange={(e) => setUnidad(e.target.value)} />
                        </div>
                    </div>

                    {/* Componente Modular de Homologación WITSML */}
                    <SelectorNemotecnicoWitsml
                        witsmlNemo={witsmlNemo}
                        witsmlDes={witsmlDes}
                        witsmlUmd={witsmlUmd}
                        witsmlFactor={witsmlFactor}
                        localUmd={unidad}
                        variables={variables}
                        currentVarId={idVar}
                        onChange={handleWitsmlChange}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}> Close </Button>
                    <Button variant="primary" onClick={() => updateVar()}>
                        Save changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
